module.exports = __webpack_public_path__ + "img/logo.6d74c709.png";